import { render, staticRenderFns } from "./CardIeaAppMain.vue?vue&type=template&id=1837b749"
import script from "./CardIeaAppMain.vue?vue&type=script&lang=js"
export * from "./CardIeaAppMain.vue?vue&type=script&lang=js"
import style0 from "./CardIeaAppMain.vue?vue&type=style&index=0&id=1837b749&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports